<template>
  <div class="custom-popover-container">
    <div class="custom-popover-btn" @click="togglePopover">⚙️</div>
    <div v-if="showPopover" class="custom-popover-content mbl" @click.stop>
      <div class="popover-header">🌊欢迎来访-风与异乡人🍃</div>
      <div class="popover-body">
        <div class="type-row" @click="handleTypeClick('life')">
          <span>云箋</span>
          <span class="count">{{ analysis.life }}</span>
        </div>
        <div class="type-row" @click="handleTypeClick('nature')">
          <span>时光</span>
          <span class="count">{{ analysis.museum }}</span>
        </div>
        <div class="type-row" @click="handleTypeClick('danmaku')">
          <span>流萤</span>
          <span class="count">{{ analysis.danmaku }}</span>
        </div>
        <div class="type-row" @click="handleTypeClick('travels')">
          <span>足迹</span>
          <span class="count">{{ analysis.travels }}</span>
        </div>
        <div class="type-row no-click">
          <span>访问</span>
          <span class="count">{{ analysis.visit }}</span>
        </div>

        <div class="divider"></div>

        <div class="type-row" @click="toggleSakura">
          <span>花瓣</span>
          <span class="count">{{ sakuraEnabled ? 'ON' : 'OFF' }}</span>
        </div>

        <div class="type-row go-update" @click="handleTypeClick('verlog')">
          <span>查看更新记录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';
export default {
  name: 'Tips',
  props: {
    analysis: {
      type: Object,
      default: () => ({
        life: 0,
        museum: 0,
        danmaku: 0,
        visit: 0
      })
    },
    sakuraEnabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showPopover: false
    };
  },
  methods: {
    togglePopover() {
      this.showPopover = !this.showPopover;
      if (this.showPopover) {
        this.$nextTick(() => {
          document.addEventListener('click', this.handleClickOutside);
        });
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.closePopover();
      }
    },
    closePopover() {
      this.showPopover = false;
      document.removeEventListener('click', this.handleClickOutside);
    },
    handleTypeClick(type) {
      switch (type) {
        case 'life': router.push("/life"); break;
        case 'nature': router.push("/nature"); break;
        case 'danmaku': router.push("/danmaku"); break;
        case 'verlog': router.push("/verlog"); break;
        case 'travels': router.push("/travels"); break;
      }
      this.closePopover();
    },
    toggleSakura() {
      this.$emit('toggle-sakura');
    }
  }
};
</script>

<style scoped>

.custom-popover-container {
  position: fixed;
  right: 6px;
  bottom: 215px;
  z-index: 9999;
}

/* 按钮保持你原来的风格 */
.custom-popover-btn {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
  border-radius: 100%;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  font-weight: 500;
  backdrop-filter: blur(10px);
}

.custom-popover-btn:hover {
  transform: scale(1.15);
  box-shadow: 0 0 12px rgba(255, 180, 180, 0.3);
}

/* 弹窗主体 —— 艺术排版核心 */
.custom-popover-content {
  position: absolute;
  right: 60px;
  bottom: 0;
  width: 220px;
  border-radius: 10px;
  padding: 26px 22px;
  color: var(--font-color-1);
}

.popover-header {
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 20px;
  color: var(--font-color-1);
  letter-spacing: 1px;
}

.divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.15);
  margin: 14px 0;
}

.popover-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.type-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 6px 4px; */
  font-size: 14px;
  /* color: rgba(255, 255, 255, 0.85); */
  border-radius: 10px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.type-row:hover {
  background: rgba(255, 255, 255, 0.08);
  color: var(--font-color-1);
  padding-left: 8px;
}

.type-row.no-click {
  cursor: default;
}
.type-row.no-click:hover {
  background: transparent;
  padding-left: 4px;
}

.type-row .count {
  font-weight: 600;
 color: var(--font-color-1);
}

.type-row.go-update {
  justify-content: center;
  color: var(--font-color-1);
  font-size: 13px;
  margin-top: 6px;
}
.type-row.go-update:hover {
  color: var(--font-color-1);
}

/* 淡入动画 */
@keyframes popover-fade-in {
  from {
    opacity: 0;
    transform: translateX(12px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>